import {useEffect, useRef, useState} from 'react'
import {KTIcon, KTSVG} from '../../../_metronic/helpers'
import {AxiosError} from 'axios'
import {homeListDeviceUserById, listDeviceUserById} from '../../modules/auth/core/_requests'
import {useIntl} from 'react-intl'
import {useSelectDeviceId, useSelectDeviceId2} from '../../../_metronic/layout/core'
import {useAuth} from '../../modules/auth'
import {SuccessfulNotify} from '../../../ToastMetods'

interface SearchTerms {
  [index: number]: string
}

function DashboardDeviceControl() {
  //Science Lab Device
  const localSelectDevice = window.localStorage.getItem('selectDevice')
  const localSelectDevices = localSelectDevice ? JSON.parse(localSelectDevice) : null
  //Sense Miner Devices
  const localSelectDevice2 = window.localStorage.getItem('selectDevice2')
  const localSelectDevices2 = localSelectDevice2 ? JSON.parse(localSelectDevice2) : null

  const {currentUser} = useAuth()
  const {SelectDeviceId, setSelectDeviceId} = useSelectDeviceId()
  const {SelectDeviceId2, setSelectDeviceId2} = useSelectDeviceId2()
  const [deviceList, setDeviceList] = useState<any>([])
  const [deviceList2, setDeviceList2] = useState<any>([])

  const [checkboxValues, setCheckboxValues] = useState(DataControl())
  const [checkboxValues2, setCheckboxValues2] = useState(DataControl2())

  const [searchTerms, setSearchTerms] = useState<SearchTerms>({})

  const intl = useIntl()
  const initialized = useRef(false)

  const getList = async () => {
    try {
      const {data} = await listDeviceUserById(Number(currentUser?.id))
      setDeviceList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const getList2 = async () => {
    try {
      const {data} = await homeListDeviceUserById(Number(currentUser?.id))
      setDeviceList2(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
    getList2()
  }, [])

  //👇 Başlangıç aşamasında herhangi bir seçili cihazlarda sorun yaşanırsa listeyi temizliyoruz.
  const checkMatchingIds = async () => {
    const controlList1 = await deviceList2.find((item: any) => item.typeName === 'Science Lab')
    const controlList2 = await deviceList2.find((item: any) => item.typeName === 'Sense Miner')

    if (controlList1 && localSelectDevices.length > 0) {
      const matching = localSelectDevices.every((id: any) =>
        controlList1.devices.some((device: any) => device.deviceId === id)
      )
      if (matching) {
        // Herhangi bir sorun yok ise Devam
      } else {
        //Kayıt Eşleşmesinde Yanlışlık Var ise Listeleri Temizliyoruz
        localStorage.setItem('selectDevice', JSON.stringify([]))
        setCheckboxValues([])
      }
    }

    if (controlList2 && localSelectDevices2.length > 0) {
      const matching = localSelectDevices2.every((id: any) =>
        controlList2.devices.some((device: any) => device.deviceId === id)
      )
      if (matching) {
        // Herhangi bir sorun yok ise Devam
      } else {
        //Kayıt Eşleşmesinde Yanlışlık Var ise Listeleri Temizliyoruz
        localStorage.setItem('selectDevice2', JSON.stringify([]))
        setCheckboxValues2([])
      }
    }
  }

  const handleCheckboxChange = (index: number, id: number) => {
    const data = deviceList.filter((i: any) => i.deviceId === id)
    const deviceName = data[0].deviceThingName
    const selectedDevicesId = data[0].deviceId
    setSelectDeviceId((prevIds: number[]) => {
      const isSelected = prevIds.includes(selectedDevicesId)
      if (isSelected) {
        //👇 Eğer seçili cihaz kimliği zaten varsa, cihaz kimliğini çıkar
        SuccessfulNotify(`${deviceName} ${intl.formatMessage({id: 'DEVICE.SELECTED.REMOVE'})}`)
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? false : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeden Çıkarıp Sonucu Döndürüyoruz.
        return prevIds.filter((id) => id !== selectedDevicesId)
      } else {
        //👇 Eğer seçili cihaz kimliği yoksa, cihaz kimliğini ekle
        SuccessfulNotify(
          `${deviceName} ${intl.formatMessage({
            id: 'DEVICE.SELECTED.SUCCESS',
          })}`
        )
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? true : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeye Ekleyip Sonucu Döndürüyoruz.
        return [...prevIds, selectedDevicesId]
      }
    })
  }

  const handleCheckboxChange2 = (index: number, id: number) => {
    const data = deviceList.filter((i: any) => i.deviceId === id)
    const deviceName = data[0].deviceThingName
    const selectedDevicesId = data[0].deviceId
    setSelectDeviceId2((prevIds: number[]) => {
      const isSelected = prevIds.includes(selectedDevicesId)
      if (isSelected) {
        //👇 Eğer seçili cihaz kimliği zaten varsa, cihaz kimliğini çıkar
        SuccessfulNotify(`${deviceName} ${intl.formatMessage({id: 'DEVICE.SELECTED.REMOVE'})}`)
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues2((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? false : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeden Çıkarıp Sonucu Döndürüyoruz.
        return prevIds.filter((id) => id !== selectedDevicesId)
      } else {
        //👇 Eğer seçili cihaz kimliği yoksa, cihaz kimliğini ekle
        SuccessfulNotify(
          `${deviceName} ${intl.formatMessage({
            id: 'DEVICE.SELECTED.SUCCESS',
          })}`
        )
        //👇 `checkboxValues` durumunu da güncelliyoruz
        setCheckboxValues2((prevValues: boolean[]) =>
          prevValues.map((value, i) => (i === index ? true : value))
        )
        //🤙 İlgili Cihaz Id Değerini Listeye Ekleyip Sonucu Döndürüyoruz.
        return [...prevIds, selectedDevicesId]
      }
    })
  }

  //👇 SelectDeviceId değiştiğinde local alandaki selectDevice a seçili cihaz bilgisini aktarıyoruz.
  useEffect(() => {
    if (initialized.current) {
      checkMatchingIds()
      window.localStorage.setItem('selectDevice', JSON.stringify(SelectDeviceId))
    } else {
      initialized.current = true
    }
  }, [SelectDeviceId])

  //👇 SelectDeviceId2 değiştiğinde local alandaki selectDevice2 a seçili cihaz bilgisini aktarıyoruz.
  useEffect(() => {
    if (initialized.current) {
      checkMatchingIds()
      window.localStorage.setItem('selectDevice2', JSON.stringify(SelectDeviceId2))
    } else {
      initialized.current = true
    }
  }, [SelectDeviceId2])

  //👇 Başlangıçta Seçili Cihaz Bilgisini CheckBoxValues ve SelectDeviceId e aktarıyoruz.
  useEffect(() => {
    const firstData = DataControl()
    setCheckboxValues(firstData)
    setSelectDeviceId(localSelectDevices ? localSelectDevices : [])
  }, [deviceList2])

  //👇 Anlık SelectDeviceId değiştiğinde CheckBoxValues değişiyor.
  useEffect(() => {
    setCheckboxValues(() => {
      const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Science Lab')

      if (scienceLabItem) {
        return scienceLabItem.devices.map((item: any) =>
          (SelectDeviceId || []).includes(item.deviceId)
        )
      }

      return []
    })
  }, [SelectDeviceId])

  //👇 Scince Lab Başlangıçta Seçili Cihaz Bilgisini Döndürüyoruz.
  function DataControl() {
    const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Science Lab')

    if (scienceLabItem) {
      return scienceLabItem.devices.map((item: any) =>
        (localSelectDevices || []).includes(item.deviceId)
      )
    }

    return []
  }

  //👇 Başlangıçta Seçili Cihaz Bilgisini CheckBoxValues ve SelectDeviceId e aktarıyoruz.
  useEffect(() => {
    const firstData = DataControl2()
    setCheckboxValues2(firstData)
    setSelectDeviceId2(localSelectDevices2 ? localSelectDevices2 : [])
  }, [deviceList2])

  //👇 Anlık SelectDeviceId2 değiştiğinde CheckBoxValues2 değişiyor.
  useEffect(() => {
    setCheckboxValues2(() => {
      const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Sense Miner')

      if (scienceLabItem) {
        return scienceLabItem.devices.map((item: any) =>
          (SelectDeviceId2 || []).includes(item.deviceId)
        )
      }

      return []
    })
  }, [SelectDeviceId2])

  //👇 Sense Miner Başlangıçta Seçili Cihaz Bilgisini Döndürüyoruz.
  function DataControl2() {
    const scienceLabItem = deviceList2.find((item: any) => item.typeName === 'Sense Miner')

    if (scienceLabItem) {
      return scienceLabItem.devices.map((item: any) =>
        (localSelectDevices2 || []).includes(item.deviceId)
      )
    }

    return []
  }

  const getRandomColorClass = (index: number) => {
    const colors = ['bg-primary', 'bg-success', 'bg-danger', 'bg-warning', 'bg-info', 'bg-dark']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  const getRandomColorClass2 = (index: number) => {
    const colors = ['primary', 'success', 'danger', 'warning', 'info', 'dark']
    const colorIndex = index % colors.length
    return colors[colorIndex]
  }

  const [showAllDevices, setShowAllDevices] = useState(Array(deviceList2.length).fill(false))
  const defaultDeviceCount = 4

  const handleShowAllDevices = (index: number) => {
    const updatedShowAllDevices = [...showAllDevices]
    updatedShowAllDevices[index] = !updatedShowAllDevices[index]
    setShowAllDevices(updatedShowAllDevices)
  }

  // 👇 Search Metin Güncelleme
  const handleSearchTermChange = (index: number, value: string) => {
    setSearchTerms({...searchTerms, [index]: value})
  }

  // 👇  Arama İşlemleri
  const keys = ['deviceThingName']

  const search = (list: any, index: number) => {
    let term = searchTerms[index]
    if (term) {
      return list.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(term.toLocaleLowerCase()))
      )
    } else {
      return list
    }
  }

  return (
    <>
      {deviceList2.map((i: any, index: number) => {
        let visibleDevices = searchTerms[index]
          ? search(i.devices, index)
          : showAllDevices[index]
          ? i.devices
          : i.devices.slice(0, defaultDeviceCount)

        return (
          <div key={index} className='col-xl-4'>
            <div className={`card card-xl-stretch mb-5 mb-xl-8`}>
              {/* 👇  Title 👇 */}
              <div className='card-header border-0'>
                <h3 className='card-title fw-bold text-dark'>{i.typeName}</h3>

                <div className='card-toolbar'>
                  {/* begin::Menu */}
                  <button
                    type='button'
                    className={`btn btn-sm btn-icon btn-color-${getRandomColorClass2(
                      index
                    )} btn-active-light-${getRandomColorClass2(index)}`}
                  >
                    <KTIcon iconName='category' className='fs-2' />
                  </button>

                  {/* end::Menu */}
                </div>
              </div>
              {/* 👆  Title 👆 */}
              {/* 👇  Search Bar 👇 */}
              <div className='d-flex align-items-center px-5 mx-2 mb-3'>
                <div
                  className={`d-flex bg-light align-items-center rounded position-relative square border border-${getRandomColorClass2(
                    index
                  )} w-100 `}
                >
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className={`svg-icon-1 position-absolute ms-5 text-${getRandomColorClass2(
                      index
                    )}`}
                  />
                  <input
                    id={`search${index}`}
                    type='text'
                    className='form-control form-control-solid ps-14'
                    placeholder={`Search ${i.typeName}`}
                    value={searchTerms[index] || ''}
                    onChange={(e) => handleSearchTermChange(index, e.target.value)}
                  />
                </div>
              </div>
              {/* 👆  Search Bar 👆 */}

              <div className='card-body pt-2'>
                {/* begin::Item */}
                {visibleDevices.map((item: any, index: number) => {
                  return (
                    <div key={index} className='d-flex align-items-center mb-8'>
                      {/* begin::Bullet */}
                      <span
                        className={`bullet bullet-vertical h-40px ${getRandomColorClass(index)}`}
                      />
                      {/* end::Bullet */}
                      {/* begin::Checkbox */}
                      <div className='form-check form-check-custom form-check-solid mx-5'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name={`myDeviceRadio${i.typeName}`}
                          id={`myDeviceRadio${i.typeName}`}
                          onClick={(e) => e.stopPropagation()}
                          checked={
                            i.typeName === 'Science Lab'
                              ? /*!!checkboxValues[index]*/ SelectDeviceId.includes(item.deviceId)
                              : i.typeName === 'Sense Miner'
                              ? /*!!checkboxValues2[index]*/ SelectDeviceId2.includes(item.deviceId)
                              : false
                          }
                          onChange={() =>
                            i.typeName === 'Science Lab'
                              ? handleCheckboxChange(index, item.deviceId)
                              : i.typeName === 'Sense Miner'
                              ? handleCheckboxChange2(index, item.deviceId)
                              : null
                          }
                        />
                      </div>
                      {/* end::Checkbox */}
                      {/* begin::Description */}
                      <div className='flex-grow-1'>
                        <a href='#' className='text-gray-800 text-hover-primary fw-bold fs-6'>
                          {item.deviceThingName}
                        </a>
                      </div>
                      {/* end::Description */}
                    </div>
                  )
                })}

                {/* end:Item */}
                {search(i.devices, index).length > defaultDeviceCount && (
                  <div className='d-flex flex-row-reverse'>
                    <button
                      type='button'
                      className={`btn btn-${getRandomColorClass2(index)} mt-3`}
                      onClick={() => handleShowAllDevices(index)}
                    >
                      {showAllDevices[index]
                        ? intl.formatMessage({id: 'HOMEPAGE.HIDE'})
                        : intl.formatMessage({id: 'HOMEPAGE.SHOWALL'})}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default DashboardDeviceControl
